<script setup>
import { computed, ref } from 'vue';

import NextButton from 'dashboard/components-next/button/Button.vue';

import { playgroundContent } from '../../helpers/kraftchatAIPlaygroundConfig';

import KraftchatAIPlaygroundAnswer from './KraftchatAIPlaygroundAnswer.vue';
import KraftchatAIPlaygroundDetails from './KraftchatAIPlaygroundDetails.vue';
import KraftchatAIPlaygroundKnowledge from './KraftchatAIPlaygroundKnowledge.vue';

defineProps({
  result: {
    type: Object,
    default: null,
  },
});

const showDetails = ref(false);

const detailsButtonLabel = computed(() => {
  return showDetails.value
    ? playgroundContent.hideDetailsLabel
    : playgroundContent.showDetailsLabel;
});

const toggleDetails = () => {
  showDetails.value = !showDetails.value;
};
</script>

<template>
  <div class="contents">
    <section
      v-if="result"
      class="space-y-5 rounded-xl border border-n-weak bg-n-background p-5"
    >
      <div
        class="flex flex-col gap-3 md:flex-row md:items-start md:justify-between"
      >
        <KraftchatAIPlaygroundAnswer :result="result" />

        <div class="flex shrink-0 justify-end">
          <NextButton
            type="button"
            color="slate"
            variant="ghost"
            size="sm"
            class="whitespace-nowrap"
            :label="detailsButtonLabel"
            @click="toggleDetails"
          />
        </div>
      </div>

      <KraftchatAIPlaygroundKnowledge
        :documents="result.knowledge_documents || []"
      />

      <KraftchatAIPlaygroundDetails v-if="showDetails" :result="result" />
    </section>
  </div>
</template>
